import lag from "./lagModule";
import spelare from "./spelareModule";
import aktiviteter from "./aktiviteterModule";
import underlag from "./underlagModule";
import platser from "./platserModule";
import aktivitetstyper from "./aktivitetstyperModule";
import idrott from "./idrottModule";
import statistik from "./statistik.js";

export default {
    namespaced: true,
    modules: {
        lag: lag,
        spelare: spelare,
        aktiviteter: aktiviteter,
        underlag: underlag,
        platser: platser,
        aktivitetstyper: aktivitetstyper,
        idrott: idrott,
        statistik: statistik,
    },
    mutations: {
        reset(state) {},
    },
};
